import { Flex, Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import environment from "src/utils/environment";
import Dialog from "src/components/Dialog";
import { Subtitle } from "src/atoms/typography";

const Dot = () => (
  <Box bg="warningBase" width="8px" borderRadius="100%" height="8px" />
);

export default function MultiConnectionFailure({
  isOpen,
  onDismiss,
  errorStations,
  avatars
}) {
  const { t } = useTranslation();
  const { isBibino } = environment;
  return (
    <Dialog
      type="warning"
      isOpen={isOpen}
      heading={t(
        isBibino
          ? "parentStation.multiConnectionFailureDialog.heading"
          : "parentStation.connectionFailureDialog.heading"
      )}
      text={isBibino && t("parentStation.multiConnectionFailureDialog.text")}
      buttons={[
        {
          text: t("buttons.ok"),
          onClick: onDismiss
        }
      ]}
      additionalContent={
        errorStations &&
        Object.values(errorStations).map((station, i) => {
          return (
            <Flex alignItems="center" key={i}>
              <Dot />
              <Subtitle ml="12px" key={station?.name} color="mediumEmphasis">
                {station?.name}
              </Subtitle>
              <Subtitle ml="8px" color="mediumEmphasis">
                ({avatars[station.avatarId]?.name || t("avatar.myAvatar")})
              </Subtitle>
            </Flex>
          );
        })
      }
    />
  );
}
